<template>
  <div class="login">
    <ucar-title>{{ title }}</ucar-title>
    <ucar-img-header
      :type="vuexRegType === '6' ? 'login-team' : 'login'"
    ></ucar-img-header>
    <div class="login-body">
      <div class="login-row">
        <input
          type="tel"
          placeholder="请输入手机号"
          name="mobile"
          v-model="info.mobile"
          maxlength="11"
          :class="{ 'mobile-disable': !enableChangeMobile }"
        />
      </div>
      <div class="login-row" v-if="showVerifyImg">
        <input
          type="text"
          placeholder="请输入图形验证码"
          name="imgCode"
          v-model="info.imgCode"
          maxlength="4"
          :class="{ 'mobile-disable': !enableChangeMobile }"
        />
        <div
          class="login-verify-img"
          v-html="verifyImg"
          @click="imgChange"
        ></div>
      </div>
      <div class="login-row">
        <input
          type="text"
          placeholder="请输入短信验证码"
          name="authCode"
          class="login-auth-input"
          v-model="info.authCode"
          :class="{ 'login-auth-input-able': enableInputAuthCode }"
          maxlength="6"
        />
        <div
          class="login-verify-btn"
          :class="{ 'login-verify-able': validMobile && enableGetVerify }"
          @click="submitVerify"
        >
          {{ verifyText }}
        </div>
      </div>
      <button
        type="button"
        class="btn-submit"
        :class="{ 'btn-submit-enable': validMobile && validAuthCode }"
        @click="submit"
      >
        {{ this.joinMode === 'join' ? '立即加入' : '登录' }}
      </button>
    </div>
    <div class="login-footer">
      登录即表示同意
      <span @click="$router.push('/protocol')">《服务合作协议》</span>
    </div>
    <login-dialog
      v-if="showDialog"
      @close="showDialog = false"
      :type="joinType"
      :company-name="lastCompanName"
      :other-company-name="vuexCompanyName"
      @transform="transform"
      @next="next"
    ></login-dialog>
    <risk-dialog v-if="showRiskDialog" @agree="$router.push(nextPath)" />
  </div>
</template>

<style lang="stylus">
@import '../../styles/variable.styl';

.login {
  display: flex;
  flex-flow: column nowrap;
  background-color: #fff;

  .login-body {
    background-color: #fff;
    position: relative;
    z-index: 2;
    flex-grow: 1;
    padding: 0 30px;

    .login-row {
      box-sizing: border-box;
      height: 114px;
      border-bottom: 1px solid $ucar_light_border; /* no */
      display: flex;
      align-items: center;

      &:nth-last-of-type(1) {
        margin-bottom: 60px;
      }

      input {
        flex: 1 0 auto;
        height: 100px;
        line-height: normal;
        box-sizing: border-box;
        font-size: $ucar_font_h4;
      }

      .login-verify-img {
        width: 194px;
        height: 68px;
        border-radius: 8px;
        pointer-events: auto;
        background-color: #fafafa;

        svg {
          height: 100%;
          width: 100%;

          path {
            fill: #f00 !important;
          }
        }
      }

      .login-auth-input {
        pointer-events: none;
      }

      .login-verify-btn {
        height: 66px;
        line-height: 66px;
        box-sizing: border-box;
        border-left: 1px solid $ucar_light_border; /* no */
        padding: 0 30px;
        color: $ucar_font_assist_color;
        pointer-events: none;
        font-size: $ucar_font_h5;
      }

      .login-verify-able {
        color: $ucar_main_color;
        pointer-events: auto;
      }

      .mobile-disable {
        pointer-events: none;
      }

      .login-auth-input-able {
        pointer-events: auto;
      }
    }
  }

  .login-footer {
    background-color: #fff;
    padding: 40px 0;
    text-align: center;
    font-size: $ucar_font_h6;
    line-height: 1;
    color: $ucar_font_assist_color;

    span {
      color: $ucar_price_color;
    }
  }
}
</style>

<script>
import LoginDialog from '../../components/login-dialog'
import RiskDialog from '../../components/risk-dialog'
import valid from '../../utils/valid-check'
import ucarStorage from '../../utils/storage.js'
import {
  getVerifyCodeImg,
  getVerifyMessage,
  login,
  join,
  transformJoinType,
  teamLogin,
  transformNewJoinType,
  gaeaQuery,
} from '../../api'
import { checkFailText } from '../../utils/constants'
export default {
  components: {
    LoginDialog,
    RiskDialog,
  },
  data() {
    return {
      joinMode: '', // 空字符串为登录，join为加入
      joinType: 0, // 0立即加入，1企业转个人， 2个人转企业， 3变更企业
      enlistStatus: null,
      showDialog: false,
      showRiskDialog: false,
      nextPath: null,
      dialogType: 1,
      lastCompanName: '',
      info: {
        mobile: '',
        authCode: '',
        imgCode: '',
      },
      verifyImg: '',
      initCount: 60,
      timer: null,
      enableChangeMobile: true,
      verifyText: '获取验证码',
      enableInputAuthCode: false,
      showVerifyImg: false,
      enableReGetVerify: true,
      syncCount: 0,
      submitted: false,
    }
  },
  computed: {
    validMobile() {
      return valid.mobile(this.info.mobile) === ''
    },
    enableGetVerify() {
      return /^[\w\d]{4,4}$/.test(this.info.imgCode) && this.enableReGetVerify
    },
    validAuthCode() {
      return this.info.authCode.length === 6
    },
  },
  watch: {
    'info.mobile'(val) {
      if (val.length === 11) {
        this.showVerifyImg = true
      }
    },
  },
  methods: {
    async transform() {
      this.showDialog = false
      this.setVuexPersonMobile(this.info.mobile)
      const body = {
        serviceCityId: this.vuexCurrentCity.cityId,
        recruitChannel: this.vuexDriverType,
        companyId: this.vuexCompanyId,
        mobile: this.vuexPersonMobile,
      }
      // 添加邀请码信息
      if (this.vuexInviteCode) body.invitationCode = this.vuexInviteCode
      // 添加邀请类型信息
      if (this.vuexChannelType) body.invitationType = this.vuexChannelType
      // 添加微信openid
      if (this.vuexWxQuery && this.vuexWxQuery.wx_Open_ID)
        body.openId = this.vuexWxQuery.wx_Open_ID
      // 添加userIdCompany参数
      if (this.vuexWxQuery && this.vuexWxQuery.userId)
        body.userId = this.vuexWxQuery.userId
      const res = await transformJoinType(body)
      if (res.resultCode === 0) {
        this.setVuexRecruitId(res.recruitId)
        this.changeStatusToFillInfo()
        this.$router.push('/driver-info')
      } else {
        this.$alert('系统异常')
      }
    },
    next() {
      this.changeStatusToFillInfo()
      this.$router.push('/driver-info')
    },
    imgChange() {
      getVerifyCodeImg().then((res) => {
        this.verifyImg = res
      })
    },
    countDown() {
      if (this.timer) return
      this.enableChangeMobile = false
      this.verifyText = '发送中'
      this.enableInputAuthCode = true
      this.timer = setInterval(() => {
        this.initCount -= 1
        this.enableReGetVerify = false
        this.verifyText = `${this.initCount}s`
        if (this.initCount === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.initCount = 60
          this.enableChangeMobile = true
          this.enableReGetVerify = true
          this.verifyText = '重新发送'
        }
      }, 1000)
    },
    submitVerify() {
      // this.trackEvent('XQ_signup_fsyzm_click')
      const body = {
        mobile: this.info.mobile,
        validateCodeType: this.vuexRegType !== '6' ? 6 : 8,
        verifyCodeImg: this.info.imgCode,
      }
      getVerifyMessage(body).then(
        (data) => {
          if (!data.showImgCode) {
            this.countDown()
            this.imgChange()
          }
        },
        () => {
          this.imgChange()
          this.enableSubmit = true
          this.enableChangeMobile = true
        }
      )
    },
    async join() {
      this.submitted = true
      // 22 西安
      const serviceCityId = this.vuexCurrentCity.cityId
      try {
        const body = {
          serviceCityId,
          channel: 1,
          mobile: this.info.mobile,
          verificationCode: this.info.authCode,
          validateCodeType: '6',
        }
        // 添加邀请码信息
        if (this.vuexInviteCode) {
          body.invitationCode = this.vuexInviteCode
          // 司机端分享或者扫二维码来源也属于司机端
          body.enlistSource = 3
        }
        // 添加邀请类型信息
        if (this.vuexChannelType) body.invitationType = this.vuexChannelType
        // 添加微信openid
        if (this.vuexWxQuery && this.vuexWxQuery.wx_Open_ID)
          body.openId = this.vuexWxQuery.wx_Open_ID
        // 添加userIdCompany参数
        if (this.vuexWxQuery && this.vuexWxQuery.userId)
          body.userId = this.vuexWxQuery.userId
        // 判断来源且不是从司机端分享或扫码过来的
        if (this.vuexFrom && !this.vuexInviteCode) {
          this.trackEvent('司招招募渠道来源', this.vuexFrom)
          if (this.vuexFrom.slice(0, 6) === 'wechat') {
            body.enlistSource = 2
          } else if (this.vuexFrom === 'driverApp') {
            body.enlistSource = 3
          } else if (this.vuexFrom === 'guanwangQRcode') {
            body.enlistSource = 1
          } else if (this.vuexFrom === 'hengdaxingluo') {
            body.enlistSource = 4
          } else {
            const fromReg = /^10\d{1,3}$/
            const legalFrom = fromReg.test(this.vuexFrom)
            if (legalFrom) {
              body.enlistSource = this.vuexFrom
            }
          }
        }
        if (this.vuexDriverType === '2') {
          body.channel = 2
          body.companyId = this.vuexCompanyId
        }
        const res = await join(body)
        this.submitted = false
        if (res.resultCode === 5) {
          const offLine = checkFailText.settledByLogin
          this.$alert({
            type: 'confirm',
            dsc: offLine,
            okText: '我知道了，下载App',
            center: true,
            callback: () => {
              location.assign('https://m.10101111.com/ptdapp/d')
            },
          })
          return
        }
        const timeRes = await gaeaQuery({ key: 'enlistCache' })
        const expires = timeRes.value * 60
        this.setVuexPersonMobile(this.info.mobile)
        this.setVuexRecruitId(res.enlistId)
        console.log(typeof expires)
        if (expires !== 0) {
          ucarStorage.setStorage('mobile', this.info.mobile, expires)
          ucarStorage.setStorage('recruitId', res.enlistId, expires)
        }
        res.enlistTag === 1
          ? this.setVuexNewRecruit(true)
          : this.setVuexNewRecruit(false)
        // enlistStatus: 0-新注册 1-已注册 2-报名中 3-待入驻 4-已入驻 5-已終止 6-已拒绝
        // resultCode: 0-新建招募单 4-已存在招募单
        // enlistTag招募单标识: 1-新；2-旧
        // 因为招募流程改了好几版，有些司机在原来的招募流程中报过名的话，就会有就得招募单
        // 因为旧的招募单还可以继续审核处理生成司机，所以存在旧的招募单就不再走新的报名流程了
        this.enlistStatus = res.enlistStatus
        if (
          res.resultCode !== 0 &&
          res.resultCode !== 4 &&
          res.enlistTag === 2
        ) {
          this.joinType = res.resultCode
          this.lastCompanName = res.companyName
          this.showDialog = true
        } else if (
          res.resultCode !== 0 &&
          res.resultCode !== 4 &&
          res.enlistTag === 1
        ) {
          if (res.enlistStatus === 2) {
            this.changeStatusToFillInfo()
            this.$router.push('/new-driver-info')
            return
          }
          if (res.enlistStatus === 3) {
            // 应为3
            // 有车且未提交则跳到nvi 否则去npi（无车也去npi）
            if (this.vuexOwnCarJoin && res.vehicleApply === 0) {
              this.changeStatusToFillInfo()
              this.$router.push('/new-vehicle-info')
            } else {
              this.changeStatusToReviewInfo()
              this.$router.push(`/new-progress-info?id=${res.enlistId}`)
            }
            return
          }
          const transRes = await transformNewJoinType(body)
          if (transRes.resultCode === 0) {
            // res.enlistStatus 1.已注册 2.报名中 3.待入驻
            if (res.enlistStatus === 1) {
              // 应为1
              this.changeStatusToFillInfo()
              this.$router.push('/new-driver-info')
            }
          } else {
            this.$alert('系统异常')
          }
        } else if (res.resultCode === 4 && res.enlistTag === 2) {
          this.changeStatusToReviewInfo()
          this.$alert({
            type: 'confirm',
            dsc: '您已申请过神州专车司机',
            showCancel: true,
            center: true,
            okText: '查看申请进度',
            cancelText: '取消',
            callback: () => {
              this.$router.push(`/progress-info?id=${res.enlistId}`)
            },
          }) // 新招募
        } else if (res.resultCode === 4 && res.enlistTag === 1) {
          // res.enlistStatus 1.已注册 2.报名中 3.待入驻
          if (res.enlistStatus === 1 || res.enlistStatus === 2) {
            // 应为1
            this.changeStatusToFillInfo()
            this.$router.push('/new-driver-info')
          } else if (res.enlistStatus === 3) {
            // 应为3
            if (this.vuexOwnCarJoin && res.vehicleApply === 0) {
              this.changeStatusToFillInfo()
              this.$router.push('/new-vehicle-info')
            } else {
              this.changeStatusToReviewInfo()
              await this.$router.push(`/new-progress-info?id=${res.enlistId}`)
            }
          }
        } else if (res.resultCode === 0) {
          this.changeStatusToFillInfo()
          this.$router.push('/new-driver-info')
        } else {
          this.changeStatusToFillInfo()
          this.$router.push(`/driver-info`)
        }
      } catch (error) {
        this.submitted = false
      }
    },
    async login() {
      this.submitted = true
      try {
        const res = await login({
          mobile: this.info.mobile,
          verificationCode: this.info.authCode,
          validateCodeType: '6',
        })
        this.submitted = false
        if (res.resultCode !== 0) {
          this.$alert('对不起，此手机号尚未报名')
          return
        }
        this.setVuexPersonMobile(this.info.mobile)
        this.changeStatusToReviewInfo()
        this.setVuexRecruitId(res.enlistId)
        if (res.enlistTag === 1) {
          this.setVuexLoginType(1)
          this.$router.push(`/new-progress-info?id=${res.enlistId}`)
        } else if (res.enlistTag === 2) {
          this.setVuexLoginType(2)
          this.setVuexRegType(`${res.channel}`)
          this.$router.push(`/progress-info?id=${res.enlistId}`)
        }
      } catch (error) {
        this.submitted = false
      }
    },
    async teamLogin() {
      this.submitted = true
      try {
        const res = await teamLogin({
          mobile: this.info.mobile,
          verificationCode: this.info.authCode,
          validateCodeType: '8',
        })
        this.submitted = false
        this.setVuexPersonMobile(this.info.mobile)
        if (res.recruit && res.id) {
          this.setVuexRecruitId(res.id)
          this.changeStatusToTeamReviewInfo()
          this.$router.push(`/team-result?id=${res.id}`)
        } else {
          this.changeStatusToFillInfo()
          this.$router.push('/team-info')
        }
      } catch (error) {
        this.submitted = false
      }
    },
    submit() {
      const errorInfo =
        valid.mobile(this.info.mobile) || valid.verifyCode(this.info.authCode)
      if (errorInfo) {
        this.$alert(errorInfo)
        return
      }
      if (this.submitted) return
      this.trackEvent('XQ_signup_ljjr_click')
      if (this.vuexRegType === '6') {
        this.teamLogin()
        return
      }
      if (this.joinMode) {
        this.join()
      } else {
        this.login()
      }
    },
  },
  mounted() {
    // 进入登录页需要刷新登录状态并重置个人信息相关缓存
    this.resetLoginStatus()
    this.resetInfo()
    if (this.$route.query.regType)
      this.setVuexRegType(this.$route.query.regType)
    // 判断是从立即加入进入还是从登录入口进入
    this.joinMode = this.$route.query.joinMode || ''
    if (this.vuexRegType === '6') this.title = '神州专车车队招募'
    this.imgChange()
  },
  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave', {
      to,
      from,
      next,
      enlistStatus: this.enlistStatus,
      cityId: this.vuexCurrentCity.cityId,
      nextPath: this.nextPath,
    })
    // 司机报名城市为西安 & 司机没有报名信息或者报名信息状态为已注册（即司机仅登录过但没有提交过身份信息）弹出风险提示弹窗
    if (
      ['/new-driver-info', '/new-new-vehicle-info'].includes(to.fullPath) &&
      [0, 1].includes(this.enlistStatus) &&
      Number(this.vuexCurrentCity.cityId) === 22 &&
      !this.nextPath
    ) {
      console.log('risk popup')
      this.showRiskDialog = true
      this.nextPath = to.fullPath
      return
    }
    next()
  },
}
</script>
